<script>
export default {
    setup(){
   window.location.href='https://hschoolh5.jimicloud.com/jumpIndex?params=aW1laT0yMyZuYW1lPeW8oCZhcHBpZD0yZDAxZWM3OWNjNDFkZWYyOGQxNWU1OTIzNWNhMTg0YQ==&appkey=5d403b176d7e59295cefc87d3737c92b&time=1673314151234'
   
   },
     
}
</script>